import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import PaymentRealizedSharedFile from './PaymentRealizedSharedFile';

export default function PaymentRealizedMade() {
  return (
    <PaymentRealizedSharedFile
      type="S"
      title="Listado de pagos efectuados"
      excelName="Pagos-efectuados-a-proveedores"
      entity="pymt/accomplished-payment"
      permission={ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_SHOW}
      destroyPermission={ConstantPermissions.PYMT_ACCOMPLISHED_PAYMENTS_DESTROY}
    />
  );
}
